import Vue from "vue"
import Vuex from "vuex"

import login from "./modules/login"
import business from "./modules/business"
import rightholders from "./modules/rightholders"
import enterprise from "./modules/enterprise"
import annualreport from "./modules/annualreport"

import {calendar} from "../api/google-api"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    business,
    rightholders,
    enterprise,
    annualreport
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // getHoliday: async () => {
    //   let res = await calendar.listHolidays()
    //   return res
    // }
  }
});
